import { memo } from 'react';
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer';
import { DateValue } from '@/components/tableDrawer';
import { ColumnsGenerator } from '@/utils/tableUtils';
import { GetBrokerMedicalRequests } from '@/api/endpoints';
import Status from './RowsCells/Status/Status';
import useNavs from '@/hooks/useNavs';
import { CategoryRequestCell } from './RowsCells/RowsData';
import "./style.css"
import { CRRender } from '@/components/crRender';
import { MISSING_DATA_STATUS } from '@/data/status';
import ActionBtn from '@/pages/accountManager/medical/shared/ActionBtn/ActionBtn';
import { useNavigate } from 'react-router-dom';

const MedicalRequests = () => {
    const { BrokerNav } = useNavs();
    const navigate = useNavigate();

    const columns = [
        ColumnsGenerator.SearchableTextCell('groupName'),
        ColumnsGenerator.SearchableTextCell('patientName', "patientName"),
        ColumnsGenerator.CustomCell('category', (original) => <CategoryRequestCell original={original} />),
        ColumnsGenerator.SearchableTextCell('selectedProvider', "provider-name"),
        ColumnsGenerator.CustomCell('requestDate', (original) => <DateValue value={original.requestDate} />),
        ColumnsGenerator.CustomCell('status', (original) => <Status status={{ name: original?.orderStatus, id: original?.orderStatusId }} />),
        ColumnsGenerator.CustomCell('action', (original) =>
            <div className='broker-actions'>
            <CRRender isRender={original.missingDataStatus == MISSING_DATA_STATUS.AskingForMissingData}>
            <ActionBtn onClick={() => viewmissingData(original)} className="missing-data" tooltipName={"fill-missing-data"} icon={"akar-icons:question-fill"} />
            </CRRender>
            <ActionBtn onClick={() => viewRequestDetails(original)} title="show-details" tooltipName={"show-details"} className="details-info" icon={"fluent:eye-16-filled"} />
            </div>),
    ]

    const viewRequestDetails = (original) =>
        BrokerNav(`medical-requests/${original?.id}`)
    const viewmissingData = (original) =>
        navigate(`/panel/broker/medical-requests/${original?.patientId}/missing-data`,{
            state:{
                patientId:original?.patientId,
                missingDataMsg:original?.missingDataMsg,
                patient:original
            }
        })
    return (
        <ReportContent
            tableAPI={GetBrokerMedicalRequests}
            columns={columns}>
            <ReportHeader>
                <ReportSearch />
            </ReportHeader>
        </ReportContent>
    );
}

export default memo(MedicalRequests);